import { Component, HostListener } from '@angular/core';
import 'hammerjs';
import { Router } from '@angular/router';
import { GlobalService } from './global.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent {
  @HostListener("click", ['$event'])
  doClick($event:Event){
    //this.global.verifySession();
  }
  constructor(private router:Router, public global: GlobalService){

  }
  ngOnInit(){

  }
  onActivate(event:any){
    try {

    }
    catch (error) {

    }
  }
}
